import { parseCuitDigits } from './formatters';

// Pesos del dígito verificador del CUIT/CUIL (módulo 11), en orden.
const PESOS_VERIFICADOR = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

/** Dígito verificador para los primeros 10 dígitos; null si el resto da 10 (no existe). */
const digitoVerificador = (primeros10) => {
  const suma = PESOS_VERIFICADOR.reduce((acc, peso, i) => acc + peso * Number(primeros10[i]), 0);
  const resto = 11 - (suma % 11);
  if (resto === 11) return 0;
  return resto === 10 ? null : resto;
};

/** CUIT con 11 dígitos y dígito verificador correcto (acepta guiones, puntos y espacios). */
export const isValidCuit = (value) => {
  const texto = String(value ?? '');
  if (/[^\d\s.-]/.test(texto)) return false;
  const digits = parseCuitDigits(texto);
  if (!/^\d{11}$/.test(digits)) return false;
  return digitoVerificador(digits) === Number(digits[10]);
};

/** Mensaje para mostrar debajo de un campo de CUIT; '' si es válido. */
export const describeCuitError = (value) => {
  const texto = String(value ?? '').trim();
  if (!texto) return 'Ingresá el CUIT.';
  if (/[^\d\s.-]/.test(texto)) return 'El CUIT solo puede tener números y guiones.';
  if (parseCuitDigits(texto).length !== 11) return 'El CUIT debe tener 11 dígitos.';
  if (!isValidCuit(texto)) return 'El CUIT no es válido: revisá el dígito verificador.';
  return '';
};
